/**
 * A simple publish/subscribe interface
 *
 */
const Handle = function(eventName, callback, thisArg) {
    this.eventName = eventName;
    this.proxyHandler = function(data) {
        callback.apply(thisArg, data);
    };
};

const Topic = function() {
    this.init(function() {});
};

Topic.prototype.init = function(countChange) {
    let handles = [];

    this._remove = (handle) => {
        handles = handles.filter(h => h !== handle);
        handle.unsubscribed = true;
        countChange(handles.length);
    };

    this._add = (handle) => {
        handles.push(handle);
        countChange(handles.length);
    };

    this._trigger = (eventName, data) => {
        handles.filter(h => h.eventName === eventName).forEach(h => h.proxyHandler(data));
    };

    this.reset = () => {
        handles.forEach(handle => handle.unsubscribed = true);
        handles = [];
        countChange(0);
    }
};

/**
 * Subscribe to event so that a specific function is called when a message is published to that event.
 * @param eventName Name of the event to subscribe to
 * @param handler Callback function to be called
 * @param thisArg "this" inside handler
 * @returns Handle A handle that can be used to unsubscribe
 */
Topic.prototype.subscribe = function(eventName, handler, thisArg) {
    const handle = new Handle(eventName, handler, thisArg);
    this._add(handle);
    return handle;
};

/**
 * Unsubscribe from an event
 * @param handle The handle returned from subscribe or subscribeOnce
 */
Topic.prototype.unsubscribe = function(handle) {
    if (handle && handle.eventName && !handle.unsubscribed) {
        this._remove(handle);
    }
};

/**
 * Subscribe to an event, and unsubscribe after the handler is called once
 * @param eventName Name of the event to subscribe to
 * @param handler Callback function
 * @param thisArg "this" inside handler
 * @returns Handle Handle to unsubscribe early
 */
Topic.prototype.subscribeOnce = function(eventName, handler, thisArg) {
    const handle = new Handle(eventName, () => {
        this.unsubscribe(handle);
        handler.apply(thisArg, arguments);
    });
    this._add(handle);
    return handle;
};

/**
 * Cause all handlers for a specific event to be triggered.  The data parameter will be passed to all
 * handlers.
 * @param eventName Name of the event to trigger
 * @param data... Arguments to pass to the event handlers
 */
Topic.prototype.publish = function(eventName) {
    var data = [];
    for (var i = 1; i < arguments.length; i++) {
        data.push(arguments[i]);
    }
    this._trigger(eventName, data);
};

export default Topic;
